module.exports = __webpack_public_path__ + "static/media/stupebrett.eb899939.svg";